import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPinIcon } from '@heroicons/react/24/outline';

/**
 * Friendly empty state shown when an event slug/id doesn't resolve.
 * Replaces the legacy "Oups, élément non trouvé" + SVG.
 */
export default function EventNotFound() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-container flex-col items-center justify-center px-4 py-20 text-center">
      <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-brand-50">
        <MapPinIcon className="h-11 w-11 text-brand-300" />
        <span className="absolute -right-1 -top-1 flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-base font-bold text-brand-900">
          ?
        </span>
      </div>
      <h1 className="mt-6 font-display text-2xl font-bold text-ink sm:text-3xl">
        {t('detail.notFoundTitle')}
      </h1>
      <p className="mt-2.5 max-w-md text-sm text-ink-muted sm:text-base">
        {t('detail.notFoundBody')}
      </p>
      <Link
        to="/events"
        className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-500 px-6 py-3 text-sm font-semibold text-white shadow-card transition-colors hover:bg-brand-600"
      >
        {t('detail.notFoundCta')}
        <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4 rtl:rotate-180" aria-hidden>
          <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z" clipRule="evenodd" />
        </svg>
      </Link>
    </div>
  );
}
